module.exports = __webpack_public_path__ + "fromBrideToMother-jp-r.5f8cabe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToMother-jp-r.jpg
// module id = PO81
// module chunks = 0